import { Currency } from '../entities/Currency';
import { RateJSON } from '../entities/Rate';
import { CurrencyConversion } from './currencies';

type RateCurrency = Exclude<Lowercase<Currency>, 'eur'>;

function getRate(rate: Omit<RateJSON, 'date'>, currency: string): number {
  if (currency === 'eur') {
    return 1;
  }

  const value = rate[currency as RateCurrency];

  if (value == null) {
    throw new Error(`Missing rate for currency: ${currency}`);
  }

  if (value === 0) {
    throw new Error(`Rate for currency ${currency} is zero`);
  }

  return value;
}

export function getExchangeRate({ source, target, rate }: CurrencyConversion): number {
  const sourceCurrency = source.toLowerCase();
  const targetCurrency = target.toLowerCase();

  if (sourceCurrency === targetCurrency) {
    return 1;
  }

  if (!rate) {
    throw new Error('Missing rate');
  }

  const sourceRate = getRate(rate, sourceCurrency);
  const targetRate = getRate(rate, targetCurrency);

  return targetRate / sourceRate;
}

export function formatRate(source: string, target: string, rate: number): string {
  if (source === target) {
    return '';
  }

  return `1 ${source} = ${rate.toFixed(3)} ${target}`;
}